<template lang="pug">
  app-page(title="Счета на оплату" )
    reestrToolbar

    div
      v-layout(row wrap v-if="reestrList.length > 0")
        v-flex.px-4(xs4 v-for="(a, index) in reestrList" :key="index" )
          app-card(@click.native="selectReestr(a)")
            app-card-header 
              | {{ a.status.title }}
              v-spacer
              .text-right {{ a.createDate }}
            app-card-body
              app-card-title {{ a.summa }} руб.
              app-card-caption.mt-2
                | {{ specName(a) }}
              app-card-caption.mt-2
                | Согласованных заявок {{ a.countApps }}

    
    app-empty-list(v-if="isReestrLoaded && reestrList.length == 0")
      div Не найдено ни одного счета
      div За период: {{ period | periodNamed }}

    app-dialog(v-model="dialogVisible" :header="reestrName" :items="reestrItems" width="500")

    app-button-action.ma-1(v-if="reestrList.length > 0" @click="export1C") Экспорт в 1С
   
</template>

<script>
import reestrToolbar from './components/ReestrToolbar'
import moment from 'moment'
moment.locale('ru');

import { $_app_moment } from "@/common/AppMoment.js"
import { config } from '@/_helpers'
import { $_user_role as Role } from '@/common/UserUtils'

import { mapGetters, mapState } from 'vuex';

export default {
  mixins: [ $_app_moment ],
  components: {
    reestrToolbar,
  },

  methods: {
    export1C() {
      if(this.period != null){
          window.open(config.apiUrl+"specialist/export1c/"+this.period.start+"/"+this.period.end+"/export.xls", '_blank')
      }
    },
    selectReestr (r) {
      this.currentReestr = r
      this.dialogVisible = true
    },
    specName: (reestr) => {
        if(reestr.specialistGroup!=null){
          return reestr.specialistGroup.groupName
        } else {
          return reestr.specialist.persona.personaType.value==1?reestr.specialist.persona.orgName:reestr.specialistType.title+" "+reestr.specialist.persona.name
        }
    },
    printBill(t) {
      t.dialogVisible = false
//      window.open(config.apiUrl+"specialist/reestr/"+reestr.id+"/printbill", '_blank')
//      window.open("ms-word:ofv|u|"+config.apiUrl+"specialist/reestr/"+reestr.id+"/printbill/reestrb"+reestr.id+".docx", '_blank')
      window.open(config.apiUrl+"specialist/reestr/"+t.currentReestr.id+"/printbill/reestrb"+t.currentReestr.id+".docx", '_blank')
    },
    printReestr(t) {
      t.dialogVisible = false
//      window.open(config.apiUrl+"specialist/reestr/"+reestr.id+"/print", '_blank')
//      window.open("ms-word:ofv|u|"+config.apiUrl+"specialist/reestr/"+reestr.id+"/print/reestr"+reestr.id+".docx", '_blank')
      window.open(config.apiUrl+"specialist/reestr/"+t.currentReestr.id+"/print/reestr"+t.currentReestr.id+".docx", '_blank')
    },
    signReestr() {
      this.$store.dispatch('appreestr/SIGN', this.currentReestr.id).then(() => this.dialogVisible = false)
    },
  },

  data() {
    return {
      currentReestr: null,
      dialogVisible: false,
    }
  },

  filters: {
    periodNamed: function (period) {
      return period != null ? period.text : 'Все'
    },
  },


  computed: {
    ...mapState('appreestr', ['period', 'selectedSort']),
    ...mapGetters('appreestr', ['reestr','isReestrLoaded']),
    ...mapGetters('me', ['hasRole']),
    isBuh() {
      return this.hasRole([Role.accountant])
    },

    isHead() {
      return this.hasRole([Role.headofdepartment])
    },

    reestrName () {
      return this.currentReestr ? 'заявка на оплату ('+ this.currentReestr.summa + ' руб.)' : ''
    },

    reestrList() {
      let list = (this.selectedType == null) ? this.reestr : this.reestr.filter(c => c.specialistType.value == this.selectedType.value)
      if (list) {
        switch (this.selectedSort) {
          case 1:
            list.sort((a, b) => a.summa-b.summa)
            break;
          default:
            list.sort((a, b) => b.createDate.localeCompare(a.createDate))
            break;
        }
      }
      return list
    },
    reestrItems() {
      let it = [] 
      it.push({ icon: 'print', title: 'Распечатать общий счет', action: () => this.printBill(this) })
      it.push({ icon: 'print', title: 'Распечатать реестр постановлений', action: () => this.printReestr(this) })
      if(this.isBuh && this.currentReestr!=null && this.currentReestr.status.name!='SIGN') it.push({ icon: 'gesture', title: 'Подписать реестр постановлений', action: () => this.signReestr() })
      if(this.isHead && this.currentReestr!=null && this.currentReestr.status.name!='SIGNBYHEAD') it.push({ icon: 'gesture', title: 'Подписать реестр постановлений', action: () => this.signReestr() })
      return it
    }
  },
  created() {
    this.$store.dispatch('appreestr/INIT')
  }
}


</script>

<style scoped>
</style>
